<template>
  <div class="add-client--container no-select">
    <fields-client
      :default="data"
      :search="search"
      :reset="reset"
      :submit="submitAdd"
      @submit="addClient"
    ></fields-client>
    <div v-if="!noDelete" class="btn btn-sm btn-danger" @click="deleteClient">Удалить</div>
    <div v-if="!noUpdate" class="btn btn-sm btn-success" @click="addSubmit">Сохранить</div>


    <popup
        :closeButton="deleteClientPopup.closeButton"
        :actionButton="deleteClientPopup.actionButton"
        :actionClass="deleteClientPopup.actionClass"
        :show="deleteClientPopup.show"
        @closePopup="closeDeletePopup"
        @actionPopup="deleteSubmit"
    >
      <div slot="header">Подтвердить удаление?</div>
      <div slot="body">
        Внимание! Будет удален сам клиент и <b>все его записи</b> без возможности восстановления.
        Продолжить?
      </div>
    </popup>


  </div>
</template>

<script>

import FieldsClient from "@/components/panel/clients/FieldsClient";
import Popup from "@/components/Popup";
import clientsRepository from "../../../repositories/clients";
import Formatter from "@/components/libraries/Formatter";

const formatter = new Formatter();

export default {
  name: "EditClient",
  components: {Popup, FieldsClient },
  data() {
    return {
      submitAdd: 0,
      data: {},
      deleteClientPopup: {
        show: false,
        closeButton: "Отмена",
        actionButton: "Продолжить",
        actionClass: "btn-success"
      },
      loadCounter: 0
    };
  },
  props: {
    id: Number, // ID клиента для загрузки данных
    search: String, // Строка поиска для отображения
    noUpdate: Boolean, // true - запретить изменение клиента
    noDelete: Boolean, // true - запретить удаление клиента
    reset: Boolean // будем сбрасывать на false
  },
  watch: {
    id: function() {
      this.loadCounter++;
      this.loadData();
    },
    reset: function(val) {
      if (val) {
        if(!this.loadCounter) {
          this.loadCounter++;
          this.loadData();
        }
      }else{
        this.loadCounter = 0;
      }
    }
  },
  computed: {},
  methods: {
    closeDeletePopup(){
      this.deleteClientPopup.show = false;
    },
    addSubmit() {
      this.submitAdd++;
    },
    addClient(val) {
      this.$store.dispatch("startPreloader");

      const data = {id: this.id};
      for (let key in val) {
        data[key] = val[key];
      }

      clientsRepository.update(data).then(resp => {
        this.$emit("editClient", resp.data);
        this.$store.dispatch("addNotification", {
          text: "Успешно сохранено",
          time: 3,
          color: "success"
        });
        this.$store.dispatch("stopPreloader");
      }).catch(err => {
        this.$store.dispatch("addNotification", {
          text: err.response.data.message,
          time: 6,
          color: "danger"
        });
        this.$store.dispatch("stopPreloader");
      });
    },
    deleteClient(){
      this.deleteClientPopup.show = true;
    },
    deleteSubmit(){
      this.$store.dispatch("startPreloader");

      clientsRepository.delete({id: this.id}).then(resp => {
        if(resp.data.result === 'ok'){
          this.deleteClientPopup.show = false;
          this.$emit('deleteClient');
        }
        this.$store.dispatch("stopPreloader");
      }).catch(err => {
        this.$store.dispatch("addNotification", {
          text: err.response.data.message,
          time: 6,
          color: "danger"
        });
        this.$store.dispatch("stopPreloader");
      });
    },
    loadData() {
      if (this.id !== null) {
        this.$store.dispatch("startPreloader");

        clientsRepository.getById({id: this.id}).then(resp => {
          let data = resp.data;
          if (data.birthday !== null) {
            data.birthday = formatter.phpDateToRus(data.birthday);
          }
          data.block = data.block == '0'?false:true;
          data.is_unwanted = data.is_unwanted == '0'?false:true;
          data.block_sms = data.block_sms == '0'?false:true;
          this.data = data;
          this.$store.dispatch("stopPreloader");
        }).catch(err => {
          this.$store.dispatch("addNotification", {
            text: err.response.data.message,
            time: 6,
            color: "danger"
          });
          this.$store.dispatch("stopPreloader");
        });
      }
    }
  },
  created() {
    if(!this.loadCounter){
      this.loadCounter++;
      this.loadData();
    }
  }
};
</script>

<style scoped lang="less">
.add-client--form {
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-between;
  flex-direction: row;

  & > div {
    width: 48%;
  }
}
.add-client--search {
  margin-bottom: 15px;
}
</style>
